import { ReactNode, ReactElement } from 'react';
import styles from './ui-text.module.scss';

export type UITextVariant =
    | 'h1'
    | 'h2'
    | 'h3'
    | 'large'
    | 'semiLarge'
    | 'basic'
    | 'small';

export type UITextType =
    | 'default'
    | 'default2'
    | 'white'
    | 'link'
    | 'error'
    | 'warning'
    | 'disabled';

export type UITextProps = {
    variant?: UITextVariant;
    type?: UITextType;
    bold?: boolean;
    medium?: boolean;
    underline?: boolean;
    underlineOnHover?: boolean;
    textAlign?: 'left' | 'center' | 'right';
    style?: React.CSSProperties;
    children?: ReactNode;
};
export function UIText(props: UITextProps): ReactElement {
    const {
        variant = 'basic',
        type = 'default',
        bold = false,
        medium = false,
        underline = false,
        underlineOnHover = false,
        style,
        children
    } = props;

    // Variant has a corresponding classname
    const classes = [styles.base, styles[type]];
    if (bold) {
        classes.push(styles[variant + 'Bold']);
    } else if (medium) {
        classes.push(styles[variant + 'Medium']);
    } else {
        classes.push(styles[variant]);
    }

    if (underline) {
        classes.push(styles.underline);
    }

    if (underlineOnHover) {
        classes.push(styles.underlineOnHover);
    }

    if (props.textAlign) {
        classes.push(styles[props.textAlign]);
    }

    return (
        <span className={classes.join(' ')} style={style}>
            {children}
        </span>
    );
}
